import { render } from "./Treasury.vue?vue&type=template&id=034a8442"
import script from "./Treasury.vue?vue&type=script&lang=js"
export * from "./Treasury.vue?vue&type=script&lang=js"
script.render = render

export default script